module.exports = __webpack_public_path__ + "static/media/024_icons_revised_nk_6_9_2015.0dacfd0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/024_icons_revised_nk_6_9_2015.png
// module id = 403
// module chunks = 0